/**
 * cart-fix.js
 * カートページで商品削除時に発生する中間状態表示バグを修正する。
 *
 * 原因:
 *   Fabricテーマの cart-items-component.onLineItemRemove は
 *   ① startViewTransition で empty-cart-template を即時に描画し、
 *   ② updateQuantity の fetch → morphSection → GPOConfigs.initialize() を
 *      バックグラウンドで実行する。
 *   ② が完了するまでの間（約1秒〜数秒）に DOM が段階的に書き換わり、
 *   「商品画像が右カラムに移動」「カートの中身が空ですが左→中央へ」
 *   といった中間表示が見える。
 *
 * 修正:
 *   削除ボタンクリックを capture フェーズで検知し、
 *   cart-items-component を opacity:0 で覆い隠す。
 *   cart-items-component の中身は SVT/morphSection で置換されるが、
 *   コンポーネント自身は同一インスタンスのまま残るため、
 *   付与したクラスは保持される。
 *   cart-page--empty + .cart-items__empty-button が現れた瞬間
 *   （= 最終 DOM 確定）を MutationObserver で検知してフェードインで戻す。
 *   タイムアウトとして3秒の保険も併用。
 *
 * 設置場所:
 *   theme.liquid </body> 直前、deferなし
 *   Liquid 側で {% if template.name == 'cart' %} のガードを使用する。
 */
(function () {
  'use strict';

  // スタイル注入
  var style = document.createElement('style');
  style.setAttribute('data-cartfix', '');
  style.textContent =
    'cart-items-component.__cf-hiding{opacity:0;transition:opacity .15s ease-out;}' +
    'cart-items-component.__cf-showing{opacity:1;transition:opacity .25s ease-in;}';
  document.head.appendChild(style);

  var hideTimer = null;
  var classObserver = null;

  function showAgain() {
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
    if (classObserver) { classObserver.disconnect(); classObserver = null; }
    var comp = document.querySelector('cart-items-component');
    if (!comp) return;
    comp.classList.remove('__cf-hiding');
    comp.classList.add('__cf-showing');
    // showing クラスは transition 完了後に外す（再ヒット用クリーンアップ）
    setTimeout(function () {
      var c2 = document.querySelector('cart-items-component');
      if (c2) c2.classList.remove('__cf-showing');
    }, 400);
  }

  function hideAndWatch() {
    var comp = document.querySelector('cart-items-component');
    if (!comp) return;

    // 既存のタイマー・オブザーバーをクリア（連打対策）
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
    if (classObserver) { classObserver.disconnect(); classObserver = null; }

    comp.classList.remove('__cf-showing');
    comp.classList.add('__cf-hiding');

    // 最終DOM確定の検知: cart-page--empty 付与 + .cart-items__empty-button の出現
    classObserver = new MutationObserver(function () {
      var comp2 = document.querySelector('cart-items-component');
      if (!comp2) return;
      var cp = comp2.querySelector('.cart-page');
      if (!cp) return;
      var isEmpty = cp.classList.contains('cart-page--empty');
      var hasEmptyButton = !!comp2.querySelector('.cart-items__empty-button');
      if (isEmpty && hasEmptyButton) {
        showAgain();
      }
    });
    classObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    // 保険のタイムアウト（3秒で強制復帰）
    hideTimer = setTimeout(showAgain, 3000);
  }

  // 削除ボタンのクリックを capture で拾う
  // Fabric の on:click ハンドラと並行して動く
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button.cart-items__remove');
    if (!btn) return;
    if (!document.querySelector('cart-items-component')) return;
    hideAndWatch();
  }, true);
})();